import React        from 'react';
import { render }   from 'react-dom';
import { Provider } from 'react-redux';
import registerServiceWorker from './registerServiceWorker';
import createStore  from './redux/create';
import App          from './views/App/index';
import rootSaga     from './redux/sagas/index';

const store = createStore();
store.runSaga(rootSaga);

render(
  <Provider store={store}>
    <App />
  </Provider>
  , document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js